import { Button, Dropdown } from "antd";
import { DownOutlined, FileExcelOutlined } from "@ant-design/icons";
import { t } from "i18next";
import useAppointmentExcelExport from "./useAppointmentExcelExport";

/**
 * Mobilde grid araç çubuğunun sağındaki "İşlemler ▾" menüsü (altına açılır).
 * items: sekmeye özgü işlemler ({ key, label, icon, disabled, danger, onClick }).
 * excelView verilirse ve yetki varsa sona "Excel" eklenir. Hiç öğe yoksa düğme çizilmez.
 */
export default function MobileActionsMenu({ items = [], excelView }) {
    const { canExport, exportExcel } = useAppointmentExcelExport(excelView);

    const all = [
        ...items,
        canExport && { key: 'excel', icon: <FileExcelOutlined />, label: t('Excel'), onClick: exportExcel },
    ].filter(Boolean);
    if (all.length === 0) return null;

    const menuItems = all.map(({ onClick, ...rest }) => rest);
    const onMenuClick = ({ key }) => all.find(x => x.key === key)?.onClick?.();

    return (
        <Dropdown trigger={['click']} placement="bottomRight" menu={{ items: menuItems, onClick: onMenuClick }}>
            <Button size="middle">
                {t('Actions')} <DownOutlined style={{ fontSize: 10 }} />
            </Button>
        </Dropdown>
    );
}
